module.exports = __webpack_public_path__ + "img/coloredeer_white - 副本.99388a40.png";